import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIDataObject } from '@shared/interfaces/http-service.interface';
import { PortalRole } from '../portal-roles.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PortalRolesService {
  constructor(private http: HttpClient) {}

  getPortalRoles(companyId: number) {
    return this.http.get<APIDataObject<PortalRole[]>>(
      `/companies/${companyId}/portal-roles`,
    ).pipe(map((res) => res.data));
  }
}
